import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import User from '../views/User.vue'
import SelectRole from '../views/SelectRole.vue'
import Containers from '../views/Containers.vue'
import Notifications from '../views/Notifications.vue'
import MainMenu from '../views/MainMenu.vue'
import ContainerView from '../views/ContainerView.vue'
import NewExpedient from '../views/cargador/NewExpedient.vue'
import Sealed from '../views/cargador/Sealed.vue'
import EmptyContainer from '../views/transitario/EmptyContainer.vue'
import CreateExpedient from '../views/transitario/CreateExpedient.vue'
import UploadDocs from '../views/UploadDocs.vue'
import DownloadDocs from '../views/DownloadDocs.vue'
import PickupOrder from '../views/transportista/PickupOrder.vue'
import PickupContainer from '../views/transportista/PickupContainer.vue'
import store from '@/store'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      requiresNotAuth: true
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: User,
    meta: {
      requiresNotAuth: true
    }
  },
  {
    path: '/selectRole',
    name: 'SelectRole',
    component: SelectRole,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/containers',
    name: 'Containers',
    component: Containers,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/notifications',
    name: 'Notifications',
    component: Notifications,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/mainmenu',
    name: 'MainMenu',
    component: MainMenu,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/containerview',
    name: 'ContainerView',
    component: ContainerView,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/newExpedient',
    name: 'NewExpedient',
    component: NewExpedient,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/sealed',
    name: 'Sealed',
    component: Sealed,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/createExpedient',
    name: 'CreateExpedient',
    component: CreateExpedient,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/emptyContainer/:type',
    name: 'EmptyContainer',
    component: EmptyContainer,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/uploadDocs/:type',
    name: 'UploadDocs',
    component: UploadDocs,
    props: true,
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: '/downloadDocs/:type',
    name: 'DownloadDocs',
    component: DownloadDocs,
    props: true,
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: '/pickupOrder',
    name: 'PickupOrder',
    component: PickupOrder,
    props: true,
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: '/pickupContainer',
    name: 'PickupContainer',
    component: PickupContainer,
    props: true,
    meta: {
      requiresAuth: true,
    }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.requiresNotAuth)) {
    if (!store.getters['user/isLoggedIn']) {
      next()
      return
    }
    next('SelectRole')
  } else {
    next()
  }
})
router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters['user/isLoggedIn']) {
      next()
      return
    }
    next('Login')
  } else {
    next()
  }
})




export default router
